exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n\n.gameComingLogo{\n    display: inline;\n\twidth: 90%;\n}\n.gameComingReleaseDate{\n\tmargin-top: 8px;\n    margin-bottom: 0px;\n    margin-left: 0px;\n    margin-right: 0px;\n\n\ttext-align: center;\n\n}\n.gameComingDescription{\n\n}\n\n.gameComingPresse{\n    height: 200px;\n}\n\n.gameComingPartner{\n    height: 200px;\n}\n\n.gameComingVideo{\n    height: 200px;\n}\n\n.gameComingImgLink{\n    width:65%;\n\n}\n\n.gameComingSplash{\n\tposition: relative;\n\n\n\twidth:90%;\n\n}\n.gameComingGameInfos{\n\tposition: relative;\n\n\ttext-align: center;\n\n\twidth:100%;\n\n\tmargin-left: auto;\n    margin-right: auto;\n\n}\n.carouselContainer{\n\tposition: relative;\n\twidth: 90%;\n\tjustify-content : center;\n\n\n\tmargin-right : auto;\n\tmargin-left : auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/css/gameComing.css
// module id = 81
// module chunks = 0